import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

interface FaqItem {
  id: number;
  question: string;
  answers: string[];
  isOpen: boolean;
}

@Component({
  selector: "app-hoi-dap",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./hoi-dap.component.html",
  styleUrl: "./hoi-dap.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HoiDapComponent implements OnInit {
  faqs: FaqItem[] = [];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadFaqs();
    // Lắng nghe sự kiện đổi ngôn ngữ để cập nhật lại danh sách câu hỏi
    this.translate.onLangChange.subscribe(() => {
      this.loadFaqs();
    });
  }

  loadFaqs(): void {
    this.translate.get('FAQ.ITEMS').subscribe((items: any[]) => {
      this.faqs = items.map(item => ({
        ...item,
        isOpen: false // Mặc định đóng tất cả khi đổi ngôn ngữ
      }));
      this.cdr.markForCheck();
    });
  }

  toggle(id: number): void {
    this.faqs = this.faqs.map((item) => ({
      ...item,
      isOpen: item.id === id ? !item.isOpen : false,
    }));
    this.cdr.markForCheck();
  }

  trackById(_: number, item: FaqItem): number {
    return item.id;
  }
}